import Table, { TBody } from 'components/UIKit/Table';
import QCEntityColumns from './Columns';
import QCEntityRow from './Row';

const QCEntityTable = ({
  children,
  descriptions,
  IconComponent,
  order,
  router,
  sort,
}: any): React.Element => (
  <Table>
    <QCEntityColumns
      order={order}
      sort={sort}
      />
    <TBody>
      {children.map((child, badKey) => (
        <QCEntityRow
          description={descriptions[child.error].description}
          IconComponent={IconComponent}
          key={badKey} // loosened to ensure API errors are displayed
          // key={`${child.node_id}-${child.last_updated}-${child.error}`}
          router={router}
          >
          {child}
        </QCEntityRow>
      ))}
    </TBody>
  </Table>
);

export default QCEntityTable;
